interface UserInfo {
  userId: string;
  username: string;
  email: string;
  roles: string[];
  contractId?: number;
}
 
class AuthService {
  getUserDetails(): UserInfo | null {
    try {
      const userInfoString = sessionStorage.getItem('user_info');
      if (!userInfoString) return null;
     
      const userInfo = JSON.parse(userInfoString);
      if (userInfo.contractId) {
        userInfo.contractId = parseInt(userInfo.contractId);
      }
      if (userInfo.userId) {
        userInfo.userId = parseInt(userInfo.userId);
      }
     
      return userInfo;
    } catch (error) {
      console.error('Error parsing user info:', error);
      return null;
    }
  }
 
  setUserDefaultContract(contractId: number): void {
    try {
      const userInfoString = sessionStorage.getItem('user_info');
      if (!userInfoString) return;
     
      const userInfo = JSON.parse(userInfoString);
      userInfo.contractId = contractId;
      sessionStorage.setItem('user_info', JSON.stringify(userInfo));
    } catch (error) {
      console.error('Error setting user default contract:', error);
    }
  }
 
  getToken(): string | null {
    return sessionStorage.getItem('access_token');
  }
 
  getRefreshToken(): string | null {
    return sessionStorage.getItem('refresh_token');
  }
 
  setTokens(accessToken: string, refreshToken: string): void {
    sessionStorage.setItem('access_token', accessToken);
    sessionStorage.setItem('refresh_token', refreshToken);
  }

  setUserInfo(userId: string, username: string, email: string, userRoles: string, contractId?: number
    ): void {
      const roles: string[] = userRoles?.split(',');
      const userInfo: UserInfo = {
        userId,
        username,
        email,
        roles,
        contractId,
      };
    sessionStorage.setItem('user_info', JSON.stringify(userInfo));
  }
 
  loggedIn(): boolean {
    return !!sessionStorage.getItem('access_token');
  }
 
  logOut(): void {
    const maintainMobileAppStatus = sessionStorage.getItem('is_app') === 'true';
    sessionStorage.clear();
   
    if (maintainMobileAppStatus) {
      sessionStorage.setItem('is_app', 'true');
      if ((window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage('{"signOut": "true"}');
      }
    }
  }
 
  redirectToLogin(): void {
    // Updated to use React Router instead of direct href
    if (typeof window !== 'undefined' && window.location) {
      window.location.hash = '/login';
    }
  }
 
  getCurrentContractId(): number | null {
    const contractId = sessionStorage.getItem('current_contract');
    return contractId ? parseInt(contractId) : null;
  }
  
 
  getCurrentContract(): { Id: number; Name: string } | null {
    const contractId = sessionStorage.getItem('current_contract');
    const contractName = sessionStorage.getItem('current_contract_name');
    return contractId && contractName ? { Id: parseInt(contractId), Name: contractName } : null;
  }
 
  setCurrentContract(contractId: number, contractName: string): void {
    sessionStorage.setItem('current_contract', contractId.toString());
    sessionStorage.setItem('current_contract_name', contractName);
  }
}
 
export const auth = new AuthService();
export default auth;